import errors from './fr/errors';
import main from './fr/main';
import formats from './fr_MU/formats';

export default { ...main, ...errors, ...formats };
